import Vue from 'vue'

export const state = () => ({
  url: "",
  token: "",
  id: "",
});
export const actions = {
}
export const mutations = {
  setUrl(state, url){
    state.url = url
  },
  setToken(state, token){
    state.token = token
  },
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
